import api from '../libs/api';

export default {

getDashboardStatusVise: (page, status, formId, initiatorIds, fromDate, toDate) => {
  return api().get(`/dashboard/status-vise`, {
    params: {
      page: page,
      status: status,
      form_id: formId,
      ...(initiatorIds && initiatorIds.length > 0 && { initiators: initiatorIds.join(",") }),
      ...(fromDate && { from_date: fromDate }),
      ...(toDate && { to_date: toDate }),
    },
  }).then(res => res.data);
},

}